import { render, staticRenderFns } from "./TopGatewaysBySentMessages.vue?vue&type=template&id=19fb493d&"
import script from "./TopGatewaysBySentMessages.vue?vue&type=script&lang=js&"
export * from "./TopGatewaysBySentMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports